// extracted by mini-css-extract-plugin
module.exports = {"detailModal":"PaymentModal_detailModal__NuV_p"};